import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Minus, Plus } from 'lucide-react';

import scss from './TextToolbar.module.scss';

const MIN_SIZE = 1;
const MAX_SIZE = 2000;

const clampSize = (value) => Math.min(MAX_SIZE, Math.max(MIN_SIZE, Math.round(value)));

function FontSizeInput({ value, onChange, onStep }) {
  const { t } = useTranslation('mediaStudio');
  const [draft, setDraft] = useState(value == null ? '' : String(value));

  useEffect(() => {
    setDraft(value == null ? '' : String(value));
  }, [value]);

  const commitDraft = () => {
    const next = Number(draft);
    if (draft !== '' && Number.isFinite(next) && next !== value) {
      onChange(clampSize(next));
    } else {
      setDraft(value == null ? '' : String(value));
    }
  };

  const step = (direction) => {
    if (value == null && onStep) {
      onStep((size) => clampSize(size + direction));
      return;
    }
    const base = value ?? Number(draft) ?? 0;
    onChange(clampSize(base + direction));
  };

  return (
    <div className={scss.sizeInput}>
      <button
        type='button'
        className={scss.sizeStep}
        aria-label={t('fontSizeDecrease')}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => step(-1)}>
        <Minus size={12} />
      </button>
      <input
        type='text'
        inputMode='numeric'
        aria-label={t('fontSize')}
        title={t('fontSize')}
        value={draft}
        placeholder='—'
        onChange={(event) => setDraft(event.target.value.replace(/[^\d]/g, ''))}
        onBlur={commitDraft}
        onKeyDown={(event) => {
          event.stopPropagation();
          if (event.key === 'Enter') {
            commitDraft();
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
            step(event.key === 'ArrowUp' ? 1 : -1);
          }
        }}
      />
      <button
        type='button'
        className={scss.sizeStep}
        aria-label={t('fontSizeIncrease')}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => step(1)}>
        <Plus size={12} />
      </button>
    </div>
  );
}

export default FontSizeInput;
